import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Auth is delivered by an httpOnly cookie (`khudhha_auth`) set by the backend on login.
// `withCredentials: true` ensures the browser sends/receives that cookie automatically.
export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

// In-memory bearer fallback. The cookie is the primary session; this bearer only exists
// for the current tab (never persisted to localStorage) and is used when the cookie
// cannot be sent (e.g., a proxied preview origin where SameSite=Lax blocks the cookie
// on cross-site XHR, or when the edge rewrites CORS headers to invalid `*`+credentials).
let _bearer = null;
export function setAuthBearer(token) { _bearer = token || null; }
export function getAuthBearer() { return _bearer; }

// Current branch context. The backend re-validates it on every request (never trusted blindly).
let _branchId = localStorage.getItem("kheffah_branch_id") || null;
export function setBranchHeader(id) { _branchId = id || null; }

api.interceptors.request.use((config) => {
  if (_bearer) config.headers.Authorization = `Bearer ${_bearer}`;
  if (_branchId && !config.headers["X-Branch-Id"]) config.headers["X-Branch-Id"] = _branchId;
  return config;
});

export function formatErr(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return err?.message || "حدث خطأ";
}
